import { render, staticRenderFns } from "./PalletTable.vue?vue&type=template&id=97dea932&scoped=true"
import script from "./PalletTable.vue?vue&type=script&lang=ts"
export * from "./PalletTable.vue?vue&type=script&lang=ts"
import style0 from "./PalletTable.vue?vue&type=style&index=0&id=97dea932&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97dea932",
  null
  
)

export default component.exports